import React from 'react';
import { motion } from 'framer-motion';

const ProfileCard = ({ isVisible }) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white rounded-2xl shadow-lg overflow-hidden mx-auto"
      style={{ 
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        width: '672px',
        maxWidth: '100%'
      }}
    >
      {/* Top Black Banner - 35-40% of card height */}
      <div className="bg-black text-white px-8 py-10 flex items-center justify-end relative" style={{ minHeight: '160px' }}>
        <h1 className="text-3xl font-bold leading-tight text-right">
          Design Obsessed<br />
          Product Manager
        </h1>
      </div>
      
      {/* White Content Section */}
      <div className="relative py-8" style={{ minHeight: '240px' }}>
        {/* Profile Photo - Overlapping both sections, positioned on left */}
        <div 
          className="absolute left-8 rounded-full overflow-hidden border-2 border-white shadow-md"
          style={{ 
            top: '-48px',
            width: '96px',
            height: '96px',
            zIndex: 10
          }}
        >
          <img 
            src="/profile.png" 
            alt="Aki Kim" 
            className="w-full h-full object-cover"
            style={{ transform: 'scale(1.2)' }}
          />
        </div>
        
        {/* Content Layout - Two column structure */}
        <div className="flex justify-between items-start px-8" style={{ paddingTop: '32px' }}>
          {/* Left Column - Primary Identity (below photo) */}
          <div className="flex-1 pr-8">
            <h2 className="text-3xl font-bold text-black mb-2 uppercase tracking-tight leading-tight">
              AKI KIM
            </h2>
            <p className="text-lg text-gray-900 font-semibold mb-1">
              Senior Product Manager
            </p>
            <p className="text-base text-gray-600 font-normal">
              Toronto, Ontario, Canada
            </p>
          </div>
          
          {/* Right Column - Affiliations (vertically stacked) */}
          <div className="flex flex-col gap-4 flex-shrink-0 items-end">
            {/* Wrapper to ensure both items have same width and align icons */}
            <div className="flex flex-col gap-4" style={{ width: 'fit-content' }}>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-black rounded flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-xs">B</span>
                </div>
                <span className="text-sm text-gray-700 font-normal whitespace-nowrap">Bethink Labs</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 bg-gray-800 rounded flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-xs">U</span>
                </div>
                <span className="text-sm text-gray-700 font-normal whitespace-nowrap">University of Toronto</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProfileCard;
